import { useCallback } from "react";
import { graphql, useMutation } from "react-relay/hooks";

import type { updateOidcIdentityProviderMutation } from "__generated__/updateOidcIdentityProviderMutation.graphql";

export const updateExistingOidcIdentityProviderMutation = graphql`
  mutation updateOidcIdentityProviderMutation(
    $nodeId: ID!
    $name: String
    $clientId: String
    $clientSecret: String
    $usePkce: Boolean
    $metadataUrl: String
    $metadataJson: JSONString
  ) {
    updateOidcIdentityProvider(
      nodeId: $nodeId
      name: $name
      clientId: $clientId
      clientSecret: $clientSecret
      usePkce: $usePkce
      metadataUrl: $metadataUrl
      metadataJson: $metadataJson
    ) {
      identityProviderConfiguration {
        id
        uuid
        name
        providerType
        oidcCallbackUrl
        oidcInitiateLoginUrl
        oidcUsePkce
        oidcIssuer
        oidcClientId
      }
      errors
    }
  }
`;

export const useUpdateOidcIdentityProvider = (
  onComplete?: (response: updateOidcIdentityProviderMutation["response"]) => void,
  onError?: (error: Error) => void
) => {
  const [updateOidcIdentityProvider, loading] = useMutation<updateOidcIdentityProviderMutation>(
    updateExistingOidcIdentityProviderMutation
  );

  const callback = useCallback(
    (
      nodeId: string,
      name: string | null,
      clientId: string | null,
      clientSecret: string | null,
      usePkce: boolean | null,
      metadataUrl: string | null,
      metadataJson: string | null
    ) => {
      updateOidcIdentityProvider({
        variables: {
          nodeId,
          name,
          clientId,
          clientSecret,
          usePkce,
          metadataUrl,
          metadataJson,
        },
        onCompleted: onComplete,
        onError,
      });
    },
    [updateOidcIdentityProvider, onComplete, onError]
  );
  return [callback, loading] as const;
};
